module.exports = __webpack_public_path__ + "img/idphoto_null@3x.ecc63702.png";